module.exports = {
      id: "vikatantv-usage",
      viewBox: "0 0 25.176 25.204",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#vikatantv",
      toString: function () {
        return this.url;
      }
    }